
    <div class="modal-header">
      
        <div class="modelclasebtn">
         
          <button type="button" class="close" aria-label="Close" (click)="onClose()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      <br>

      <div class="width_full_per">
        <div class="title_bar">
          <h1>Profile</h1>
        </div>
      </div>

    </div>
    <div class="modal-body">
      <div *ngIf="custProfile" class="row">
        <div class="content_section profile_section marg_center width_90_per">
          <div class="row">
            <div class="col-sm-12 col-md-2 col-lg-2 zero_left profile_image">
              <!-- <div class="profile_pic">
        <img ng-show="!profile.imgLoad" ng-src="{{profile.imageUrl}}" onerror="this.src = '/images/editprofile.jpg'" alt="Profile" />
  </div>   -->
              <div class="profile_pic">
                <img src="{{custProfile.Customer.ImagePath}}">
              </div>
            </div>
            <div class="col-sm-12 col-md-10 col-lg-10 zero_right">
              <div class="personal_detail clearfix">
                <h3>Personal Details</h3>
                <!--First Name-->
                <div class="row">
                  <div class="col-sm-12 col-md-6 col-lg-3 col-xl-2 order_s_colum">
                    <div class="order_colum">
                      <h4>Fist Name:<span>{{custProfile.Customer.FirstName}}</span></h4>
                    </div>
                  </div>
                  <!--/First Name-->
                  <!--Last Name-->
                  <div class="col-sm-12 col-md-6 col-lg-3 col-xl-2 order_s_colum">
                    <div class="order_colum">
                      <h4>Last Name:<span>{{custProfile.Customer.LastName}}</span></h4>
                    </div>
                  </div>
                  <!--/Last Name-->
                  <!--Email-->
                  <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 order_s_colum">
                    <div class="order_colum">
                      <h4>Email:<span>{{custProfile.Customer.Email}}</span></h4>
                    </div>
                  </div>
                  <!--/Email-->
                  <!--Phone-->
                  <div class="col-sm-12 col-md-6 col-lg-3 col-xl-2 col-xl-2 order_s_colum">
                    <div class="order_colum">
                      <h4>Phone:<span>{{custProfile.Customer.Phone}}</span></h4>
                    </div>
                  </div>
                  <!--/Phone-->
                  <!--Method-->
                  <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 order_s_colum">
                    <div class="order_colum">
                      <h4>
                        Method of Communication:
                        <span *ngIf="custProfile.Customer.SendEmail">Email</span>
                        <span *ngIf="custProfile.Customer.SendSMS">,</span>
                        <span *ngIf="custProfile.Customer.SendSMS">SMS</span>
                        <span *ngIf="!custProfile.Customer.SendEmail && !custProfile.Customer.SendSMS">None</span>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div class="address_details clearfix">
                <h3>Pickup & Delivery Address</h3>
                <div class="address_posti clearfix" *ngFor="let mod of custProfile.Addresses">
                  <p>{{mod?.CompleteAddress}}</p>
                  <div class="default_actions">
                    <div class="radio_button">
                      <input *ngIf="mod.ID === custProfile.DefaultAddressId" type="radio" id="address{{mod.ID}}"
                        [(ngModel)]="mod.IsDefault" [value]="true" (checked)="mod.ID === custProfile.DefaultAddressId"
                        [disabled]="true" name="address{{mod.ID}}" />
                      <label *ngIf="mod.ID === custProfile.DefaultAddressId" for="address{{mod.ID}}">Default</label>
                      <div class="check">
                        <div class="inside"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="address_posti clearfix" *ngIf="custProfile.Addresses.length==0">
                  Address is not available.
                </div>
              </div>


              <div class="address_details pay_det clearfix">
                <h3>Payment Details </h3>
                <div class="address_posti clearfix"
                  *ngFor="let mod of  custProfile.Cards">

                  <div *ngIf="!mod.IsExpired" class="expired_card">
                  </div>

                  <p>{{mod?.CardDetails}}
                    <!--<br /> <strong>Billing Address:</strong> {{mod?.BillingAddress?.CompleteAddress}} -->
                  </p>
                  <div class="default_actions">
                    <div class="radio_button">
                      <input *ngIf="mod.ID === custProfile.DefaultCardId" type="radio" id="card{{mod.ID}}"
                        name="card{{mod.ID}}" [(ngModel)]="mod.IsDefault" [value]="true"
                        (checked)="mod.ID === custProfile.DefaultCardId"
                        [disabled]="mod.ID === custProfile.DefaultCardId||!mod.IsExpired">
                      <label *ngIf="mod.ID === custProfile.DefaultCardId" for="card{{mod.ID}}">Default</label>
                      <div class="check">
                        <div class="inside"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="address_posti clearfix" *ngIf="custProfile.Cards.length==0">
                  No card available.Please enter a new card
                </div>
              </div> 
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row content_section profile_section" *ngIf="!custProfile" style="height:200px;">Loading</div>
    